import Image from 'next/image';
import RedBlobs from './images/RedBlobs.png';
import BlueEgg from './images/BlueEgg.png';
import LearnMore from './images/LearnMore.png';
import OrangeCircle from './images/OrangeCircle.png';
import GreenSmilingBacteria from './images/GreenSmilingBacteria.png';
import YellowMonster from './images/YellowMonster.png';

export function CoverSectionScience() {
  return (
    <section
      id="cover-science"
      className="bg-blue-light h-[550px] sm:h-[600px] relative overflow-hidden"
    >
      <div
        className="absolute top-[-10px] right-[60px] w-[182px] sm:w-[302px] sm:right-[160px] sm:top-[-40px] 
        md:top-0 lg:right-[320px] xl:right-[520px]
        "
      >
        <Image src={RedBlobs} alt=" " />
      </div>
      <div
        className="absolute left-[-40px] top-[120px] w-[90px] sm:w-[120px] sm:left-[-30px] sm:top-[190px] 
        md:w-[160px] lg:w-[180px] xl:w-[210px] xl:top-[130px] xl:left-0"
      >
        <Image src={BlueEgg} alt=" " />
      </div>

      <div className="flex flex-col mx-auto">
        <h1 className="mx-auto mt-[114px] sm:mt-[214px] md:mt-[190px] text-dark text-4xl sm:text-6xl">
          Our science
        </h1>
        <div className="w-[180px] mx-auto sm:w-[318px]">
          <Image src={LearnMore} alt=" " />
        </div>
      </div>
      <div
        className="absolute bottom-[80px] left-[-50px] w-[92px] sm:w-[130px] sm:left-[30px] sm:bottom-[120px] 
        md:w-[148px] md:left-[70px]
        lg:w-[208px] lg:bottom-[80px]
        xl:left-[160px]
        "
      >
        <Image src={OrangeCircle} alt=" " />
      </div>
      <div
        className="absolute bottom-[70px] right-[90px] w-[100px] sm:w-[118px] sm:bottom-0 sm:right-[70px]
        md:w-[118px] md:bottom-[30px] md:right-[90px] lg:w-[148px] lg:right-[160px]
        "
      >
        <Image src={GreenSmilingBacteria} alt=" " />
      </div>
      <div
        className="absolute bottom-[70px] w-[120px] h-[190px] right-[-20px] sm:bottom-0 
        lg:w-[180px] lg:h-[280px] lg:bottom-[40px] lg:right-[20px]
        "
      >
        <Image src={YellowMonster} alt=" " />
      </div>
    </section>
  );
}
